import { OrderOrigin, OrderOriginTitle } from '@/types';

export const orderOriginTitle: Record<OrderOrigin, OrderOriginTitle> = {
  lnpl: 'Funding',
  ppm: 'In-House',
};
